





























































import { computed } from "@vue/composition-api";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import Vue from "vue";
import { SensitivityLevelHelper } from "@/common/models";
export default Vue.extend({
  props: ["items", "info_type_name", "current_sensitivity"],
  components: { SensitivityLabel },
  setup(props) {
    const popup_props = computed(
      () =>
        props.items as [
          string,
          number,
          [number, { name: string; id: string }][]
        ]
    );

    const display_labels_group = computed(() => {
      return popup_props.value[2].filter(
        ([float_sensitivity]) =>
          SensitivityLevelHelper.floatToInt(float_sensitivity) <=
          popup_props.value[1]
      );
    });

    return { popup_props, display_labels_group };
  },
});
